import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Spinner, Text } from "./styles/small-updating-styles";
import spinner from "./img/spinner-white.gif";

const SmallUpdating = ({ noMobile }) => (
  <Wrapper noMobile={noMobile} className="animated fadeIn">
    <Spinner src={spinner} alt="Updating spinner" />
    <Text>Updating . . .</Text>
  </Wrapper>
);
SmallUpdating.propTypes = {
  noMobile: PropTypes.bool,
};
SmallUpdating.defaultProps = {
  noMobile: PropTypes.isNull,
};

export default SmallUpdating;
